<template>
  <div class="features-area">
    <div class="container">
      <div class="row justify-content-center features-wrapper">

        <div class="col-lg-4 col-md-6 col-12 "  v-for="item in featuressDatas">
          <div class="features border-0  text-center features-item-thumb"  style="background: #89d3b8 !important; ">
              <a :href="item.url" class="row">
                  <div class="col-10 ">
                      <h5><strong>{{item.name}}</strong></h5>
                      <p>{{item.note}}</p>
                  </div>
                  <div class="col-2 float-left justify-content-center" >
                    <span style="position:relative;top:30%" class="fa fa-chevron-right color-white">
                    </span>
                  </div>
              </a>
            </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

    import {getLAdvertise} from '@/api/advertise'
    export default {
        name: "features",
        data(){
          return {
            featuressDatas: []
          }
        },
      beforeCreate(){
        let _this = this
        getLAdvertise(3).then(res=>{
          if(res.data.code===200) {
            _this.featuressDatas = res.data.data
          }
        })
      }
    }
</script>

<style scoped>

  .features-item-thumb {
    display: block;
    position: relative;
    overflow: hidden;
  }

  .features-item-thumb::before, .features-item-thumb::after {
    content: "";
    position: absolute;
    opacity: 1;
    z-index: 3;
    pointer-events: none;
    -webkit-transition: all 0.4s;
    -o-transition: all 0.4s;
    transition: all 0.4s;
  }

  .features-item-thumb::before {
    left: 10px;
    right: 10px;
    top: 10px;
    bottom: 10px;
    border: 1px solid #fff;
  }

  .features-item-thumb::after {
    border-left: 1px solid #fff;
    border-right: 1px solid #fff;
    right: 10px;
    left: 10px;
    top: 10px;
    bottom:10px;
  }

  .features-item-thumb:hover::before {
    left: 10px;
    right: 10px;
    opacity: 1;
  }

  .features-item-thumb:hover::after {
    top: 10px;
    bottom: 10px;
    opacity: 1;
  }
</style>
